import { UntypedFormGroup } from '@angular/forms';
import { StatusInfo, Workspace, User, FormData } from '../../shared/interfaces';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

export interface NewWorkspaceInfo {
  name: string;
  owners: WorkspaceOwnerInfo[];
  imageUrl: string;
}

export interface WorkspaceOwnerInfo {
  name: string;
  email: string;
  avatarUrl: string;
  jobTitle: string;
  role: string;
  user?: any;
  status: string;
}

export function CreateNewWorkspaceInfo(): NewWorkspaceInfo {
  return {
    name: '',
    owners: [],
    imageUrl: '',
  };
}

export interface SetCoverImageParams {
  result: string;
  workspace: Partial<{ id: string; coverUrl: string }>;
  cacheBuster: string;
  ngUnsubscribe: any;
}

export interface SetAvatarImageOnModalParams {
  uploadModal: NgbModalRef;
  cacheBuster: string;
  workspace: Partial<{ id: string; avatarUrl: string; coverUrl: string }>;
  ngUnsubscribe: any;
}

export interface AvatarImageResult {
  avatarUrl: string;
  workspaceAvatarUrl: string;
}

export interface UserWorkspaceRole {
  user?: any;
  fullName: string;
  username: string;
  jobTitle: string;
  status?: any;
  firstName?: string;
  lastName?: string;
}

export interface SaveWorkspaceResult {
  success: boolean;
  updatedWorkspace?: Workspace;
}

export interface SaveWorkspaceParams {
  workspace: Workspace;
  form: UntypedFormGroup;
  trimString: (value: string) => string;
  ngUnsubscribe: any;
  isPending: boolean;
}

export interface InitWorkspaceUsersParams {
  workspace: Workspace;
  companyUsers: any[];
  activationStatuses: any[];
  workspaces?: any;
}

export interface AddUserToWorkspaceParams {
  formData: FormData;
  userData: User;
  users: UserWorkspaceRole[];
  companyUsers: User[];
  activationStatuses: StatusInfo[];
  workspaceId: string;
  workspaces: Workspace[];
  ngUnsubscribe: any;
}
